// extracted by mini-css-extract-plugin
export default {"tooltip":"Wn-z","sharingV2":"Xn-z","sharingIconsV2":"Yn-z","links":"Zn-z","link":"_n-z","facebookV2":"ao-z","twitterV2":"bo-z","pinterestV2":"co-z"};